<template>
  <VueTagsInput
    ref="input"
    v-model="tag"
    :tags="tags"
    :autocomplete-min-length="0"
    :autocomplete-items="filteredTags"
    :add-only-from-autocomplete="true"
    placeholder="Account tags..."
    class="tags-filter"
    v-on="$listeners"
  />
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import VueTagsInput from '@johmun/vue-tags-input'
import { slugify } from '@/utils/functions'
import { matchesQuery } from '@/utils/autocompleteFilter'
import { mapGetters } from 'vuex'

@Component({
  components: {
    VueTagsInput
  },
  computed: {
    ...mapGetters({ availableTags: 'accountTags' })
  }
})
export default class AccountTagFilter extends Vue {
  tag = ''
  tags: any[] = []
  availableTags!: any[]

  clear() {
    this.tag = ''
    this.tags = []
    this.$emit('tags-changed', [])
  }

  setTags(slugs: string[]) {
    if (!slugs?.length || !this.availableTags?.length) {
      this.tags = []

      return
    }
    this.tags = this.availableTags.filter((t: { slug: string }) =>
      slugs.includes(t.slug)
    )
  }

  get filteredTags() {
    const slugified = slugify(this.tag)

    // Tags carry both a display name and a slug. Matching the name as well as
    // the slug means "Past Due" narrows the list the same way "past-due" does;
    // the slug arm stays so queries with characters slugify strips still hit.
    return this.availableTags.filter(
      t => matchesQuery(this.tag, t.text) || matchesQuery(slugified, t.slug)
    )
  }
}
</script>

<style lang="scss">
.tags-filter .ti-tag.ti-valid {
  &:not(.ti-deletion-mark) {
    background-color: $button-blue;
    border-color: $button-blue;
    color: #fff;
  }
}
.tags-filter .ti-autocomplete {
  max-height: 150px;
  background-color: #fff !important;
  border: 1px solid #ced4da;
  border-top: none;
  color: #212529;
  .ti-item {
    color: #212529;
    > div {
      padding: 6px 10px;
    }
    &.ti-selected-item {
      background-color: $button-blue;
      color: #fff;
    }
  }
}
</style>
